/**
 * Facet displays that do not represent "pick a value from a list".
 * Any other display is considered dropdown-like, including legacy and search variants.
 */
export const NON_DROPDOWN_FACET_DISPLAYS = new Set(['TextFacet', 'BooleanFacet', 'DateRangeFacet', 'RangeSliderFacet']);

export const SELECT_FIELD_TYPES = new Set(['termset', 'reference', 'location']);

export const LABEL_OBJECT_FIELD_TYPES = new Set(['reference', 'location']);

export const CREATE_DEFAULTS_CARDINALITY = {
    single: 'single',
    multi: 'multi'
} as const;
